import { createAsyncActionTypes } from '../../helpers';

const domain = 'chapters';

const addCommentToChapter = createAsyncActionTypes(domain, 'addCommentToChapter');
const addReplyToCommentInChapter = createAsyncActionTypes(domain, 'addReplyToCommentInChapter');
const updateReplyToCommentInChapter = createAsyncActionTypes(domain, 'updateReplyToCommentInChapter');
const updateChapter = createAsyncActionTypes(domain, 'updateChapter');
const updateCommentInChapter = createAsyncActionTypes(domain, 'updateCommentInChapter');
const resolveCommentInChapter = createAsyncActionTypes(domain, 'resolveCommentInChapter');
const deleteCommentInChapter = createAsyncActionTypes(domain, 'deleteCommentInChapter');
const deleteOrUndoComments = createAsyncActionTypes(domain, 'deleteOrUndoComments');
const saveChaptersChanges = createAsyncActionTypes(domain, 'saveChaptersChanges');
const fetchProofDataByProjectId = createAsyncActionTypes(domain, 'fetchProofDataByProjectId');
const fetchProofDataByUserId = createAsyncActionTypes(domain, 'fetchProofDataByUserId');

export default {
  addCommentToChapter,
  addReplyToCommentInChapter,
  updateReplyToCommentInChapter,
  updateChapter,
  updateCommentInChapter,
  resolveCommentInChapter,
  deleteCommentInChapter,
  deleteOrUndoComments,
  saveChaptersChanges,
  fetchProofDataByProjectId,
  fetchProofDataByUserId,
};
